import type {
  FormattedChannel,
  FormattedNotification
} from '@library/types/alerts';
import { Avatar } from '@library/components/avatar/Avatar';
import { Button } from '@library/components/buttons';
import rightIcon from '@library/assets/images/right.svg';
import { useAlertNotifications } from '@bo-hooks/alerts/useAlertNotifications';
import { useState } from 'react';

export interface AlertNotificationProp {
  notification: FormattedNotification;
  setSelectedChannel: (channel: FormattedChannel) => void;
  setSpecificAlertId: (alertId: string) => void;
}

export const AlertNotification = ({
  notification,
  setSelectedChannel,
  setSpecificAlertId
}: AlertNotificationProp) => {
  const { handleReadNotification } = useAlertNotifications();

  const [acknowledged, setAcknowledged] = useState(notification.acknowledged);

  const first = notification.firstName || 'No';
  const last = notification.lastName || 'Username';

  const notificationType = notification.type;
  let notificationMessage = '';
  if (notificationType === 'tag_acknowledgement') {
    notificationMessage = 'acknowledged your alert';
  } else if (notificationType === 'channel_recommendation') {
    notificationMessage = 'recommended a channel';
  } else if (notificationType === 'message_tag') {
    notificationMessage = 'tagged you in an alert';
  }

  return (
    <div className="hover:bg-soFresh-130 relative mb-4 flex w-full items-center rounded-lg p-4">
      <div className="flex w-full gap-4">
        <Avatar />
        <div className="w-full flex-col items-baseline gap-1">
          <div className="flex w-full justify-between">
            <div className="flex items-baseline gap-2 text-sm">
              <p className="text-soClean-100 font-semibold">{`${first} ${last}`}</p>
              {notificationMessage && (
                <p className="font-light">{notificationMessage}</p>
              )}
              <p className="text-soFresh-190 gap-2 text-sm">{`${notification.timestamp.date} ${notification.timestamp.time}`}</p>
            </div>
            <div className="mt-1 flex items-center gap-2">
              {!acknowledged && (
                <p className="text-soFresh-190 text-sm">Unread</p>
              )}
              <Button
                onClick={() =>
                  handleReadNotification(
                    notification,
                    setSelectedChannel,
                    setSpecificAlertId,
                    setAcknowledged
                  )
                }
              >
                <img
                  src={rightIcon}
                  alt="View Notification"
                  className="size-3"
                />
              </Button>
            </div>
          </div>
          <div className="flex">
            <p className="text-soClean-120 text-sm">
              {`#${notification.channelName}`}
            </p>
          </div>
          <p className="text-soClean-120 text-sm">{notification.text}</p>
        </div>
      </div>
    </div>
  );
};
